import type { WebsiteHeaderPhotoSchema_NoPhoto } from '@shared/types/WebsiteHeaderSettings.types';

export const NO_PHOTO_DEFAULT: WebsiteHeaderPhotoSchema_NoPhoto = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/noPhoto-v1_1_1.json',
  presentationLayout: 'noPhoto',
  photos: undefined,
};
